<template>
    <div>
        <b-form-group
            description="Options that can be picked"
            label="Options"
            :label-cols="3"
            :horizontal="false"
        >
            
        <v-select
            taggable
            multiple
            v-model="constraints.selectables.items"
        />

        </b-form-group>
        <b-form-group
            description="Can be multiple selected"
            label="Multi-select"
            :label-cols="3"
            :horizontal="false"
        >
           <c-switch class="mx-1" color="success" variant="pill" v-model="constraints.selectables.multiple"/>
        </b-form-group>

        <b-form-group
            description="Custom values can be added"
            label="Custom"
            :label-cols="3"
            :horizontal="false"
        >
           <c-switch class="mx-1" color="success" variant="pill" v-model="constraints.selectables.custom"/>
        </b-form-group>
    </div>
</template>
<script>
import { Switch as cSwitch } from '@coreui/vue'
import vSelect from 'vue-select'

export default {
    components: {
        cSwitch,
        vSelect
    },
    props: {
        value: {
            type: Object | String
        }
    },
    data: function() {
        return {
            constraints: this.value,
            text: "",
            selected: ""
        }
    },
    methods: {
        save() {
            this.$emit('input', this.constraints)
        },

        add() {
            if (this.text != "") {
                this.constraints.selectables.items.push(this.text);
                this.selected = this.text
                this.text = ""
            }   
        }
    }
    
}
</script>